import { render, staticRenderFns } from "./recovery-password.html?vue&type=template&id=b0b34cd0&scoped=true&"
import script from "./recovery-password.js?vue&type=script&lang=js&"
export * from "./recovery-password.js?vue&type=script&lang=js&"
import style0 from "./recovery-password.css?vue&type=style&index=0&id=b0b34cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b34cd0",
  null
  
)

export default component.exports